import React from 'react';
import { Card, Space, Button, Table, Select, Input } from 'antd';
import NoticeDocEditor from '../../../components/NoticeDocEditor';
import { loadState } from './state';

const NoticeContentEditorSection = ({
  placeholders,
  placeholderRows,
  fieldOptions,
  selectedDebtorCount,
  onSmartMatchFields,
  onOpenPreview,
  onSave,
  onReloadTemplate,
  setPlaceholderFieldFor,
  setPlaceholderManualFor,
  setPlaceholders,
  editorActionRef,
  onSaved,
}) => (
  <div style={{ display: 'flex', gap: 12 }}>
    <Card
      size="small"
      title={(
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
          <span>填写项</span>
          <Space wrap>
            <Button onClick={onSmartMatchFields} disabled={placeholders.length === 0}>智能匹配</Button>
            <Button onClick={onOpenPreview} disabled={selectedDebtorCount === 0}>预览催告</Button>
            <Button type="primary" onClick={onSave}>校验并保存</Button>
            <Button onClick={onReloadTemplate}>重载模板</Button>
          </Space>
        </div>
      )}
      style={{ flex: '0 0 520px' }}
    >
      <Table
        size="small"
        rowKey="key"
        dataSource={placeholderRows}
        pagination={false}
        columns={[
          {
            title: '占位符',
            dataIndex: 'placeholder',
            key: 'placeholder',
            width: 160,
            render: (v) => String(v || '').replace(/\*/g, ''),
          },
          {
            title: '字段',
            dataIndex: 'fieldKey',
            key: 'fieldKey',
            width: 220,
            render: (v, row) => (
              <Select
                value={String(v || '') || undefined}
                placeholder="请选择字段"
                allowClear
                style={{ width: '100%' }}
                virtual={false}
                popupMatchSelectWidth={false}
                dropdownStyle={{ maxHeight: 320, overflow: 'auto', background: '#fff', zIndex: 2000 }}
                options={fieldOptions}
                onChange={(nextVal) => setPlaceholderFieldFor(row.placeholder, nextVal)}
              />
            ),
          },
          {
            title: '手动输入',
            dataIndex: 'manual',
            key: 'manual',
            render: (v, row) => (
              <Input
                value={v}
                placeholder="没有字段可匹配时手动填写"
                onChange={(e) => setPlaceholderManualFor(row.placeholder, e?.target?.value)}
              />
            ),
          },
        ]}
      />
    </Card>

    <div style={{ flex: '1 1 0' }}>
      <NoticeDocEditor
        initialHtml={(loadState().contentHtml || '')}
        templateId={loadState().selectedTemplateId}
        values={{}}
        onPlaceholdersChange={(ph) => setPlaceholders(Array.isArray(ph) ? ph : [])}
        actionRef={editorActionRef}
        hideFillPanel
        hideReload
        hideAutoFill
        hideSave
        initialPageSettings={loadState().pageSettings}
        onSaved={onSaved}
      />
    </div>
  </div>
);

export default NoticeContentEditorSection;

